"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationGallery = void 0;
var _reactRedux = require("react-redux");
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var useRecommendationGallery = function useRecommendationGallery(media) {
  var selectedVariant = (0, _reactRedux.useSelector)(_recommendationSelectors.selectSelectedHandsetVariant);
  var galleryImages = media === null || media === void 0 ? void 0 : media.filter(function (attachment) {
    return attachment.id.split('|')[0] === (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.variantId);
  }).map(function (el) {
    return {
      id: el.id,
      src: el.url
    };
  });
  return {
    galleryImages: galleryImages
  };
};
exports.useRecommendationGallery = useRecommendationGallery;